"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasRecipientsChanged = exports.calculateActivePatientsProgress = exports.getAssignedPatientsByStatus = exports.formatDuration = exports.DOCUMENT_CONTENT_MAP = exports.MUTE_NOTIFICATION_OPTIONS = exports.ACTIVE_MESSAGE_STATUS = exports.getMilesFromMeters = exports.dataURLtoFile = exports.durationInHours = exports.getImageThumbUrl = void 0;
exports.detectLinks = detectLinks;
exports.getMessageStatus = getMessageStatus;
exports.extractFilenameWithoutDimension = extractFilenameWithoutDimension;
const regex_1 = require("./regex");
const domain_1 = require("@home-health-notify/domain");
const theme_1 = require("../theme");
const useFetchSignedUrlInfoWithSocket_1 = require("../hooks/useFetchSignedUrlInfoWithSocket");
function detectLinks(text, createLinkElement) {
    if (!text)
        return [];
    const combinedRegex = regex_1.Regex.DETECT_LINKS_AND_EMAILS;
    const elements = [];
    let lastIndex = 0;
    let match;
    let keyCounter = 0;
    while ((match = combinedRegex.exec(text)) !== null) {
        const boundary = match[1] || "";
        let raw = match[2];
        const matchIndex = match.index;
        const before = text.slice(lastIndex, matchIndex);
        if (before)
            elements.push(before);
        elements.push(boundary);
        const trailingMatch = raw.match(/[),.;:!?]+$/);
        const trailing = trailingMatch ? trailingMatch[0] : "";
        if (trailing)
            raw = raw.slice(0, -trailing.length);
        lastIndex = combinedRegex.lastIndex;
        if (!raw) {
            if (trailing)
                elements.push(trailing);
            continue;
        }
        const isEmail = regex_1.Regex.email.test(raw);
        let href;
        if (isEmail) {
            href = `mailto:${raw}`;
        }
        else if (/^https?:\/\//i.test(raw)) {
            href = raw;
        }
        else if (/^[Ww][Ww][Ww]\./.test(raw)) {
            href = `https://${raw}`;
        }
        else {
            href = `https://${raw}`;
        }
        const key = `link-${keyCounter++}`;
        const linkElement = createLinkElement(key, raw, href, isEmail);
        elements.push(linkElement);
        if (trailing)
            elements.push(trailing);
    }
    if (lastIndex < text.length) {
        elements.push(text.slice(lastIndex));
    }
    return elements;
}
const getImageThumbUrl = (url) => {
    if (!url)
        return ""; // Handles pending image messages by returning empty string to show loader in pending state
    if ((0, useFetchSignedUrlInfoWithSocket_1.isBlobImage)(url))
        return url;
    const THUMBNAIL_PATH = `thumbnail/`;
    const fileName = url.substring(url.lastIndexOf("/") + 1);
    // eslint-disable-next-line prefer-destructuring
    const basePath = url.split(fileName)[0];
    return `${basePath}${THUMBNAIL_PATH}${fileName}`;
};
exports.getImageThumbUrl = getImageThumbUrl;
const durationInHours = (duration) => {
    const sec = duration; // convert value to number if it's string
    let hours = Math.floor(sec / 3600); // get hours
    let minutes = Math.floor((sec - hours * 3600) / 60); // get minutes
    let seconds = Math.floor(sec - hours * 3600 - minutes * 60); //  get seconds
    // add 0 if value < 10; Example: 2 => 02
    if (hours) {
        hours = hours < 10 ? `0${hours}` : hours;
    }
    if (minutes) {
        minutes = minutes < 10 ? `0${minutes}` : minutes;
    }
    if (seconds) {
        seconds = seconds < 10 ? `0${seconds}` : seconds;
    }
    const durationStr = `${hours || ""}${(hours ? ":" : "") + minutes || "00"}:${seconds}`;
    return durationStr;
};
exports.durationInHours = durationInHours;
const dataURLtoFile = (dataUrl, fileName) => {
    /* eslint-disable prefer-const */
    let arr = dataUrl.split(","), 
    // eslint-disable-next-line prefer-destructuring
    mime = arr[0].match(/:(.*?);/)[1], bStr = atob(arr[1]), n = bStr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bStr.charCodeAt(n);
    }
    /* eslint-enable prefer-const */
    return new File([u8arr], fileName, { type: mime });
};
exports.dataURLtoFile = dataURLtoFile;
const getMilesFromMeters = (distanceInMeter) => {
    return distanceInMeter <= 0 ? 0 : +(distanceInMeter / 1609.34).toFixed(1);
};
exports.getMilesFromMeters = getMilesFromMeters;
function getMessageStatus(visibleTo, chatId, isMessagePending, isMessageFailed = false) {
    const messageStatus = visibleTo.find(user => chatId === user.id);
    if (isMessageFailed) {
        return ACTIVE_MESSAGE_STATUS.FAILED;
    }
    else if (isMessagePending) {
        return ACTIVE_MESSAGE_STATUS.PENDING;
    }
    else if (messageStatus === null || messageStatus === void 0 ? void 0 : messageStatus.isRead) {
        return ACTIVE_MESSAGE_STATUS.READ;
    }
    else if (messageStatus === null || messageStatus === void 0 ? void 0 : messageStatus.isDelivered) {
        return ACTIVE_MESSAGE_STATUS.DELIVERED;
    }
    else {
        return ACTIVE_MESSAGE_STATUS.SENT;
    }
}
var ACTIVE_MESSAGE_STATUS;
(function (ACTIVE_MESSAGE_STATUS) {
    ACTIVE_MESSAGE_STATUS["READ"] = "READ";
    ACTIVE_MESSAGE_STATUS["DELIVERED"] = "DELIVERED";
    ACTIVE_MESSAGE_STATUS["SENT"] = "SENT";
    ACTIVE_MESSAGE_STATUS["PENDING"] = "PENDING";
    ACTIVE_MESSAGE_STATUS["FAILED"] = "FAILED";
})(ACTIVE_MESSAGE_STATUS || (exports.ACTIVE_MESSAGE_STATUS = ACTIVE_MESSAGE_STATUS = {}));
exports.MUTE_NOTIFICATION_OPTIONS = [
    { label: "15 Minutes", value: 15 },
    { label: "1 Hour", value: 60 },
    { label: "8 Hours", value: 480 },
    { label: "24 Hours", value: 1440 },
];
exports.DOCUMENT_CONTENT_MAP = {
    [domain_1.MESSAGE_CONTENT_DOCUMENT_TYPE.PDF]: {
        iconColor: theme_1.sharedDocumentColors.pdf.icon,
        bgColor: theme_1.sharedDocumentColors.pdf.background,
        icon: "file-pdf-box",
    },
    [domain_1.MESSAGE_CONTENT_DOCUMENT_TYPE.XLS]: {
        iconColor: theme_1.sharedDocumentColors.xls.icon,
        bgColor: theme_1.sharedDocumentColors.xls.background,
        icon: "file-excel-box",
    },
    [domain_1.MESSAGE_CONTENT_DOCUMENT_TYPE.XLSX]: {
        iconColor: theme_1.sharedDocumentColors.xls.icon,
        bgColor: theme_1.sharedDocumentColors.xls.background,
        icon: "file-excel-box",
    },
    [domain_1.MESSAGE_CONTENT_DOCUMENT_TYPE.DOC]: {
        iconColor: theme_1.sharedDocumentColors.doc.icon,
        bgColor: theme_1.sharedDocumentColors.doc.background,
        icon: "file-word-box",
    },
};
function extractFilenameWithoutDimension(uri) {
    // eslint-disable-next-line prefer-destructuring
    const cleanUri = uri.split("?")[0].split("#")[0];
    const segments = cleanUri.split("/");
    const lastSegment = segments[segments.length - 1];
    const decodedFilePath = decodeURIComponent(lastSegment);
    return decodedFilePath
        .replace(/^(web_|ios_|android_)/, "")
        .replace(/(_w\d+_h\d+)/, "");
}
const formatDuration = (duration) => {
    const minutes = Math.floor(duration / 60);
    const seconds = Math.floor(duration % 60);
    const formattedMinutes = minutes.toString().padStart(2, "0");
    const formattedSeconds = seconds.toString().padStart(2, "0");
    return `${formattedMinutes}:${formattedSeconds}`;
};
exports.formatDuration = formatDuration;
const getAssignedPatientsByStatus = (assignedPatients, patientStatus) => {
    var _a;
    return (((_a = assignedPatients.find((patientGroup) => patientGroup.patientStatus === patientStatus)) === null || _a === void 0 ? void 0 : _a.patients) || []);
};
exports.getAssignedPatientsByStatus = getAssignedPatientsByStatus;
const calculateActivePatientsProgress = (patients, department) => {
    const progress = {
        pending: 0,
        active: 0,
        discharged: 0,
        pendingProgress: "0%",
        activeProgress: "0%",
        dischargedProgress: "0%",
    };
    if (!department || !Array.isArray(patients)) {
        return progress;
    }
    patients.forEach(patient => {
        if (!Array.isArray(patient.servicesToPatient))
            return;
        patient.servicesToPatient.forEach(service => {
            if (service.shorthand === (department === null || department === void 0 ? void 0 : department.shortHand)) {
                switch (service.status) {
                    case domain_1.SERVICE_STATUS.PENDING:
                        progress.pending++;
                        break;
                    case domain_1.SERVICE_STATUS.ACTIVE:
                        progress.active++;
                        break;
                    case domain_1.SERVICE_STATUS.DISCHARGED:
                        progress.discharged++;
                        break;
                }
            }
        });
    });
    const total = progress.active + progress.active + progress.discharged;
    if (total > 0) {
        progress.pendingProgress = `${((progress.pending / total) * 100).toFixed(2)}%`;
        progress.activeProgress = `${(((progress.pending + progress.active) / total) * 100).toFixed(2)}%`;
        progress.dischargedProgress = "100%"; // always full bar at the end
    }
    return progress;
};
exports.calculateActivePatientsProgress = calculateActivePatientsProgress;
const hasRecipientsChanged = (prevRecipients, newRecipients) => {
    const prevIds = prevRecipients.map(r => r.id).sort();
    const newIds = newRecipients.map(r => r.id).sort();
    return (prevIds.length !== newIds.length ||
        prevIds.some((id, index) => id !== newIds[index]));
};
exports.hasRecipientsChanged = hasRecipientsChanged;
